import React from 'react';
import { IonRippleEffect } from '@ionic/react';

interface Props {
	children: React.ReactNode;
	className?: string;
	shape?: 'default' | 'circle';
	style?: any;

	onClick?: () => void;
}
const Touchable: React.FC<Props> = (props) => {
	const { children, className, style, onClick } = props;
	const shape = props.shape || 'default';

	return (
		<React.Fragment>
			<div
				id="Touchable"
				className={`ion-activatable ${className || ''} ${shape}`}
				style={style}
				onClick={() => onClick && onClick()}
			>
				{children}
				<IonRippleEffect></IonRippleEffect>
			</div>
		</React.Fragment>
	);
};

export default Touchable;
